import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'error',
    template: require('./error.component.html'),
    styles: [require('./error.component.css')]
})

export class ErrorComponent {
    
    constructor() {        
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/pages/auth/error/error.component.ts